"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _AnnouncerContext = _interopRequireDefault(require("./AnnouncerContext"));

var _Announcer = _interopRequireDefault(require("./Announcer"));

var _interfaces = require("./interfaces");

var _core = require("@emotion/core");

var LiveAnnouncer = function LiveAnnouncer(_ref) {
  var children = _ref.children;

  var _useState = (0, _react.useState)(undefined),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      politeLogMessage = _useState2[0],
      setPoliteLogMessage = _useState2[1];

  var _useState3 = (0, _react.useState)(undefined),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      politeStatusMessage = _useState4[0],
      setPoliteStatusMessage = _useState4[1];

  var _useState5 = (0, _react.useState)(undefined),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      assertiveLogMessage = _useState6[0],
      setAssertiveLogMessage = _useState6[1];

  var _useState7 = (0, _react.useState)(undefined),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      assertiveStatusMessage = _useState8[0],
      setAssertiveStatusMessage = _useState8[1];

  var announcePolite = function announcePolite(_ref2) {
    var region = _ref2.region,
        role = _ref2.role;

    switch (role) {
      case _interfaces.LiveRegionRole.Status:
        setPoliteStatusMessage(region);
        return;

      case _interfaces.LiveRegionRole.Log:
        setPoliteLogMessage(region);
        return;

      default:
        return;
    }
  };

  var announceAssertive = function announceAssertive(_ref3) {
    var region = _ref3.region,
        role = _ref3.role;

    switch (role) {
      case _interfaces.LiveRegionRole.Status:
        setAssertiveStatusMessage(region);
        return;

      case _interfaces.LiveRegionRole.Log:
        setAssertiveLogMessage(region);
        return;

      default:
        return;
    }
  };

  var updateFunctions = {
    announceAssertive: announceAssertive,
    announcePolite: announcePolite
  };
  return (0, _core.jsx)(_AnnouncerContext.default.Provider, {
    value: updateFunctions
  }, children, (0, _core.jsx)(_Announcer.default, {
    politeLogRegion: politeLogMessage,
    politeStatusRegion: politeStatusMessage,
    assertiveLogRegion: assertiveLogMessage,
    assertiveStatusRegion: assertiveStatusMessage
  }));
};

var _default = LiveAnnouncer;
exports.default = _default;